import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import VehicleTypeUpdateModalUI from './VehicleTypeUpdateModalUI.js'

class VehicleTypeUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field

      vehicleType:null,
      vehicleCount:null
    }
  }

  render() {
    return (
      <VehicleTypeUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onUpdateClick={this.onSubmit}
        onCancelCreate={this.onCancelCreate}
        onCancelUpdate={this.onCancelUpdate}
        // form fields
        vehicleType={this.state.vehicleType}
        onVehicleTypeChange={(event) => {this.setState({vehicleType: event.target.value})}}
        vehicleTypeError={this.state.vehicleTypeError}
        setVehicleTypeError={(error) => {this.setState({vehicleTypeError: error})}}
        vehicleTypeList={this.props.vehicleTypeList}
        //
        vehicleCount={this.state.vehicleCount}
        onVehicleCountChange={(event) => {this.setState({vehicleCount: event.target.value})}}
        vehicleCountError={this.state.vehicleCountError}
        setVehicleCountError={(error) => {this.setState({vehicleCountError: error})}}
      />
    )
  }

  onCancelUpdate = () => {
    this.setState({
      submitted: false, successMsg: null, errorList: null,
      vehicleTypeError:null,
      vehicleCount:null
    })
    this.props.onCancelUpdate()
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
    this.setState({
     // loanTypeList: loanTypeList,
     // appFlavorList: appFlavorList, loanPurposeList: loanPurposeList
    })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/vehicleTypes`,
      this.onSubmitCallback, {
      vehicleType:this.state.vehicleType,
      vehicleCount:this.state.vehicleCount
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Loans())
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelUpdate()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default VehicleTypeUpdateModalSF
